(function () {
  var BOOK_HANDLE = 'kinderbuch-personalisiert-mit-name';
  var PROP_KEY = 'Name für das Buch';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function findLineIndexByKey(cart, key) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) return i + 1;
    }
    return null;
  }

  function setStatus(input, text, show) {
    var status = input.parentElement.querySelector('.GiftPersonalizeStatus');
    if (!status) return;
    status.textContent = text;
    status.style.display = show ? 'inline' : 'none';
  }

  function saveName(input) {
    var key = input.getAttribute('data-line-key');
    var name = input.value.trim();

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lineIndex = findLineIndexByKey(cart, key);
        if (!lineIndex) return;
        var line = cart.items[lineIndex - 1];
        var properties = Object.assign({}, line.properties);
        if (name) {
          properties[PROP_KEY] = name;
        } else {
          delete properties[PROP_KEY];
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, properties: properties })
        });
      })
      .then(function (res) {
        if (res && res.ok) {
          setStatus(input, 'Gespeichert', true);
          setTimeout(function () { setStatus(input, '', false); }, 2000);
        }
      })
      .catch(function (e) {
        console.error('Gift personalization save failed', e);
      });
  }

  var debouncedSave = debounce(saveName, 700);

  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('GiftPersonalizeInput')) {
      debouncedSave(e.target);
    }
  });

  document.addEventListener('focusout', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('GiftPersonalizeInput')) {
      saveName(e.target);
    }
  });
})();